<template>
  <div class="users">
    <el-form :model="userData" :rules="validators" ref="userData" label-width="200px" class="new-user-form">

      <el-form-item label="Role" prop="role">
        <el-select v-model="userData.role" placeholder="User role">
          <el-option label="General" value="0"></el-option>
          <el-option label="Booking" value="1"></el-option>
          <el-option label="Admin" value="2"></el-option>            
          <el-option v-if="userIsSuperAdmin" label="Super Admin" value="3"></el-option>
        </el-select>  
      </el-form-item>

      <div v-if="userIsSuperAdmin">
        <el-form-item label="Client" prop="client_id">
          <el-select v-model="userData.client_id" placeholder="Client">
            <div v-for="client in clients" :key="client.id">
              <el-option :label="client.name" :value="String(client.id)"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item label="Name" prop="name"> 
        <el-input v-model="userData.name"></el-input> 
      </el-form-item>

      <el-form-item label="Username" prop="username"> 
        <el-input v-model="userData.username"></el-input> 
      </el-form-item>

      <el-form-item label="Email" prop="email"> 
        <el-input v-model="userData.email"></el-input> 
      </el-form-item>

      <el-form-item label="Send an email?">
        <el-switch active-text="" inactive-text="" v-model="sendAnEmail"></el-switch>
      </el-form-item>

      <el-form-item label="Generate password?">
        <el-switch active-text="" inactive-text="" v-model="generatePass"></el-switch>
      </el-form-item>

      <div v-if="generatePass"></div>
      <div v-else>
        <el-form-item label="Set password" prop="password"> 
          <el-input type="password" v-model="userData.password"></el-input> 
        </el-form-item>
        
        <el-form-item label="Confirm password" prop="checkPass"> 
          <el-input type="password" v-model="userData.checkPass"></el-input> 
        </el-form-item>
      </div>

      <el-form-item>
        <el-button type="save" @click="submit('userData')">Create</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>

</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';
import generator from 'generate-password';

export default {
  name: 'admin-new-users',
  data () {
    var validateEmail = (rule, value, callback) => {
      var emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if(!value.trim().match(emailRegex)) {
        callback(new Error("Not a valid email address."));
      }
      callback();
    };

    var validatePass = (rule, value, callback) => {
      if(!this.generatePass) {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.checkPass !== '') {
            this.$refs.userData.validateField('checkPass');
          }
        }
      }
      callback();
    };

    var validatePass2 = (rule, value, callback) => {
      if(!this.generatePass) {
        if (value === '') {
          callback(new Error('Please input the password again'));
        } else if (value !== this.userData.password) {
          callback(new Error('Two inputs don\'t match!'));
        }
      }
      callback();
    };

    return {
      pageName: 'New User',
      userData: {
        name: '',
        username: '',
        email: '',
        client_id: '',
        password: '',
        role: '',
        generated_pass: '0'
      },
      checkPass: '',
      sendAnEmail: false,
      generatePass: true,
      userIsSuperAdmin: false,
      clients: [],
      validators: {
        name: [
          { required: true, message: "Please input user's name.", trigger: 'blur'},
          { min:2, max: 99, message: "Must be between 2-99 characters.", trigger: 'blur' },
        ],
        username: [
          { required: true, message: "Please input a username.", trigger: 'blur'},    
          { min:2, max: 99, message: "Must be between 2-99 characters.", trigger: 'blur' },                
        ],
        email: [
          { required: true, message: "Please input an email.", trigger: 'blur'},    
          { min:2, max: 99, message: "Must be between 2-99 characters.", trigger: 'blur' },
          { validator: validateEmail }            
        ],
        password: [
          { validator: validatePass }
        ],
        checkPass: [
          { validator: validatePass2 }
        ],
        role: [
          { required: true, message: "Please select a user type.", trigger: 'blur'},          
        ],
        client_id: [
          { required: true, message: "Please select a client.", trigger: 'blur' },
        ]
      },
    }
  },
  methods: {
    sendEmail(userData) {

      var profile = JSON.parse(auth.getProfile());

      var context = this;

      var firstName = userData.name;
      var email = userData.email;
      var adminUsername = profile.username;
      var username = userData.username;
      var password = userData.password;
      var role = userData.role;

      var data ={
        "Messages": [{
            "From": {
              "Email": "noreply@sporte.io",
              "Name": "Sporte"
            },
            "To": [{
                "Email": `${email}`,
                "Name": `${firstName}`
            }],
          "TemplateID": 211770,
          "TemplateLanguage": true,
          "Subject": "Welcome to Sporte!",
          "Variables": {
            "first_name": `${firstName}`,
            "admin_name": `${adminUsername}`,
            "role": `${this.humanise(role)}`,
            "username": `${username}`,
            "password": `${this.generatePass ? password : ' '}`
          }
        },]
      }

      requests.sendEmail(this, data, function (result) {
        if(result.action === 'success') {
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Email sent to ' + email
          });
        } else {
          context.$message({
            showClose: true,
            type: 'error',
            message: result.msg
          });
        }
      });

    },
    newUser(){
      var userData = this.userData;

      if( this.generatePass ) {
        var pass = generator.generate({
          length: 8,
          numbers: true,
          excludeSimilarCharacters: true,
          strict: true,
        });

        if (!this.sendAnEmail)
          console.log(pass)

        userData.password = pass;
        userData.generated_pass = '1';
      }

      //Clone userdata for email, otherwise gets cleared
      var udcopy = Object.assign({}, userData);

      var context = this;
      requests.newUser(this, userData, function(result){
        if(result.action === 'success'){
          if(context.sendAnEmail) {
            context.sendEmail(udcopy);
          }

          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created user ' + userData.name
          });

          context.close();

        } else {
          console.log(userData);
          console.log(result);
          if(result.message === "Duplicate entry found") { 
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Someone with that username already exists.'
            });
          } else {
            context.$message({
              showClose: true,
              type: 'error',
              message: 'Failed to create new user'
            });
          }
        }
      });
    },
    submit(formName) {
      // console.log(this.userData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newUser();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    setClientId() {
      var profile = JSON.parse(auth.getProfile());
      this.userData.client_id = profile.client_id;      
    },
    close() {
      this.reset('userData');        
      this.$emit('close');
    },
    humanise(role) {
      if(role === 0) {
        return "General";
      } else if (role === 1) {
        return "Booking";
      } else if (role === 2) {
        return "Admin";
      } else if (role === 3) {
        return "Super Admin";
      } else {
        return "";
      }
    },
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
 
    if( this.userIsSuperAdmin ) {
      var context = this;

      requests.getAllClients(this, function(result){
        if(result.action === 'success'){
          context.clients = result.data;
        } else {
          context.$message({
            type: 'error',
            message: 'Failed to recieve clients'
          });
        }
      });
    } else {
      this.setClientId();
    }
  }
}
</script>


// WEBPACK FOOTER //
// NewUser.vue?37659d47